import { GuitarMark } from './GuitarMark.tsx';
import type { GuitarCorner } from '../lib/types.ts';

/**
 * Decorative guitar pinned to one of the four corners.
 *
 * The base guitar.svg sits naturally in the bottom-left. Each other corner is
 * a mirror of that, which is what produces the apparent rotation:
 *   bottom-left  -> identity
 *   top-left     -> flip vertical   (-scale-y-100)
 *   bottom-right -> flip horizontal (-scale-x-100)
 *   top-right    -> rotate 180      (= flip both)
 *
 * Render inside a `relative overflow-hidden` parent.
 */
const CORNER_CLASSES: Record<GuitarCorner, string> = {
  'top-left': 'left-0 top-0 -scale-y-100',
  'top-right': 'right-0 top-0 rotate-180',
  'bottom-left': 'left-0 bottom-0',
  'bottom-right': 'right-0 bottom-0 -scale-x-100',
};

export interface CornerGuitarProps {
  readonly corner: GuitarCorner;
  /** Tailwind text-color class used as the guitar fill (currentColor). */
  readonly colorClass?: string;
  readonly opacityClass?: string;
  readonly widthClass?: string;
}

export function CornerGuitar({
  corner,
  colorClass = 'text-mf-green',
  opacityClass = 'opacity-[0.08]',
  widthClass = 'w-[42vw]',
}: CornerGuitarProps) {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden>
      <div className={`absolute ${CORNER_CLASSES[corner] ?? ''} ${widthClass} aspect-927/1081 ${colorClass} ${opacityClass}`}>
        <GuitarMark className="w-full h-full" />
      </div>
    </div>
  );
}
